import React from "react";
import {withStyles} from "@material-ui/core";
import styles from "./styles";
import _ from 'lodash';

import withWidth from "@material-ui/core/withWidth/withWidth";
import {CHART_COLORS, DEFAULT_EMPTY_SECTION_MESSAGE} from '../../../../../utils/constants';
import {openMorningStartIsin} from "../../../../../utils/utils";
import {
  DEFAULT_POINT_FORMAT,
  RiskReturnChart as ProViewRiskReturnChart
} from '../../../../../components/Charts/RiskReturnChart'
import { getInstrName } from '../../../../Modelportfolios/utils';
import Legend from "../../Legend/Legend";

const POINT_FORMAT = DEFAULT_POINT_FORMAT + '<br />Anteil: <b>{point.weight:.2f}%</b></div>';

class ChartRiskReturn extends React.Component {

  renderChart() {
    const {classes, width} = this.props;
    const range = 'all';

    let data = [];

    const isMobile = ["xs"].includes(width);
    // NOTE: we need to ovverride exactly the same fields as they are "cashed" each render

    let assetsData = this.props.portfolioData['portfolio_data']['data'][0]['components']

    let mapping = {}

    assetsData.forEach(item => {
      const assetInfo = item['financial_information']['asset_info_data'];

      const name = getInstrName(assetInfo);

      mapping[assetInfo['isin']] = {
        name: name ? name : assetInfo['isin'],
        weight: item['weight']
      }
    })

    mapping['portfolio'] = {
      name: this.props.portfolioData['portfolio_data']['data'][0]['name'],
      weight: 1
    }

    let counter = 0;

    let maxValue = 0;


    if (this.props.data && this.props.data[range]) {

      if (this.props.portfolioRiskReturnData && this.props.portfolioRiskReturnData[range]) {
        for (let [isin, item] of Object.entries(this.props.portfolioRiskReturnData[range])) {

          const x = item['volatility'] * 100;
          const y = item['return'] * 100;

          let newValue = Math.abs(y);

          if (maxValue < newValue) {
            maxValue = newValue;
          }

          data.push({
            name: mapping[isin]['name'],
            color: CHART_COLORS[counter % CHART_COLORS.length],
            data: [{
              x,
              y,
              weight: undefined
            }],
            shadow: true,
            marker: {
              symbol: 'triangle'
            }
          })

          counter++;
        }
      }

      for (let [isin, item] of Object.entries(this.props.data[range])) {

        const x = item['volatility'] * 100;
        const y = item['return'] * 100;

        data.push({
          name: mapping[isin]['name'],
          isin: isin,
          color: CHART_COLORS[counter % CHART_COLORS.length],
          data: [{
            x,
            y,
            weight: mapping[isin]['weight'] * 100,
            onTooltipClick: (_item) => openMorningStartIsin(isin),
          }],
          shadow: true,
          marker: {
            symbol: 'circle'
          }
        })

        counter++;
      }

      data = _.orderBy(data, asset => asset.data[0].weight, ['desc'])

      return <div className={classes.chartContainer}>
        <ProViewRiskReturnChart
          series={data}
          pointFormat={POINT_FORMAT}
          pointFormatPF={DEFAULT_POINT_FORMAT}
          tooltipOptions={{shape: 'square', shared: true,}}
          chartOptions={{height: isMobile ? 450 : 350,}}
          mirrorYAxis
          withGridLine
        />
        <Legend data={data} flexDirection={"row"} asLink/>
      </div>
    } else {
      return <p>Dieses Diagramm kann erst 30 Tage nach der ersten Transaktion gezeigt werden</p>
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        {this.props.error
          ? (<span className={classes.errorContainer}>{this.props.error}</span>)
          : (this.props.data && this.props.portfolioData) ? this.renderChart() : (
            <span className={classes.errorContainer}>{DEFAULT_EMPTY_SECTION_MESSAGE}</span>)}
      </div>
    )
  }
}

export default withStyles(styles)(withWidth()(ChartRiskReturn))
